// extracted by mini-css-extract-plugin
export default {"rating":"ProductDetails_rating__QVm+Q"};